import React from 'react';

const Container = ({ children }) => (
  <div className='detail-container'>
    {children}
  </div>
)

export default Container;
